import React from "react";

const ProfileContext = React.createContext({
  id: "",
  first: "",
  last: "",
  gender: "",
  born: "",
  country: "",
  phone: "",
  accession: null
});

export default ProfileContext;



// WEBPACK FOOTER //
// ./src/utils/ProfileContext.js